// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"51c9b91e","821":"a4afff1c","836":"7bc42e77","869":"5a06b17d","876":"abede25c"}[chunkId] + ".chunk.js";
};